import React, { useContext } from 'react';
import { inject, observer } from 'mobx-react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import { ColorModeContext } from '../theme/colorMode';
import _useTranslate from '../hooks/_useTranslate';

// Cycles: auto -> light -> dark -> auto. A manual choice (light/dark) overrides
// the OS; 'auto' hands control back to the OS prefers-color-scheme setting.
const NEXT = { auto: 'light', light: 'dark', dark: 'auto' };

const ColorModeToggle = ({ feathersStore }) => {
  const common = _useTranslate(feathersStore.language, 'common');
  const { mode, setMode } = useContext(ColorModeContext);

  // Labels are translated (common.*) with English fallbacks.
  const LABEL = {
    auto: common.colorThemeSystem || 'System theme',
    light: common.colorThemeLight || 'Light theme',
    dark: common.colorThemeDark || 'Dark theme',
  };

  const icon =
    mode === 'light' ? <LightModeIcon sx={{ fontSize: 26 }} /> :
    mode === 'dark'  ? <DarkModeIcon sx={{ fontSize: 26 }} /> :
                       <SettingsBrightnessIcon sx={{ fontSize: 26 }} />;

  const cycle = () => setMode(NEXT[mode] || 'auto');

  return (
    <Tooltip title={LABEL[mode] || 'Color theme'}>
      <IconButton
        className="color-mode-toggle"
        onClick={cycle}
        aria-label={LABEL[mode] || 'Toggle color mode'}
        sx={{
          color: 'var(--main-text-color)',
          '&:hover': {
            color: 'var(--main-red-aux)',
            backgroundColor: 'rgba(127, 127, 127, 0.15)',
          },
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export default inject('feathersStore')(observer(ColorModeToggle));
